// extracted by mini-css-extract-plugin
export default {"wrap":"ScaleNotes_wrap__iYaTU","staff":"ScaleNotes_staff__dXkGD","playhead":"ScaleNotes_playhead__HwI22","fingering":"ScaleNotes_fingering__WSQ32"};